import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=48aad544&scoped=true&"
import script from "./Confirm.vue?vue&type=script&lang=js&"
export * from "./Confirm.vue?vue&type=script&lang=js&"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=48aad544&prod&lang=scss&"
import style1 from "./Confirm.vue?vue&type=style&index=1&id=48aad544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aad544",
  null
  
)

export default component.exports